import { render } from "./sunburst.vue?vue&type=template&id=8c1f3d60&scoped=true"
import script from "./sunburst.vue?vue&type=script&lang=js"
export * from "./sunburst.vue?vue&type=script&lang=js"

import "./sunburst.vue?vue&type=style&index=0&id=8c1f3d60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1f3d60"]])

export default __exports__